import type {SelectItem} from '@jetbrains/ring-ui/components/select/select'
import React from 'react'

import {useAppDispatch, useAppSelector} from '../../../../../../../../../hooks/react-redux'
import {useJobId} from '../../../../../../EditPipelinePage/EditPipelinePage.hooks'
import {getDraftJobs} from '../../../../../../EditPipelinePage/EditPipelinePage.selectors'
import {pipelineDraft} from '../../../../../../EditPipelinePage/slices/EditPipelinePage.slices'
import {usePipelineId} from '../../../../../../hooks/pipeline'

const parallelismOptions: ReadonlyArray<SelectItem> = [
  {
    key: '1',
    label: '1',
  },
  {
    key: '2',
    label: '2',
  },
  {
    key: '3',
    label: '3',
  },
  {
    key: '4',
    label: '4',
  },
  {
    key: '5',
    label: '5',
  },
]

function useJobParallelism() {
  const pipelineId = usePipelineId()
  const jobId = useJobId()!
  const parallelismCount = useAppSelector(state =>
    String(getDraftJobs(state, pipelineId)?.[jobId]?.parallelism || '1'),
  )
  const dispatch = useAppDispatch()
  const handlerParallelismSelect = (value: SelectItem | null) => {
    dispatch(
      pipelineDraft.actions.setParallelismCount({
        id: pipelineId,
        jobId,
        value: Number(value?.key),
      }),
    )
  }

  const selectedOption = React.useMemo(
    () => parallelismOptions.find(value => value.key === parallelismCount),
    [parallelismCount],
  )

  return {
    parallelismOptions,
    selectedOption,
    handlerParallelismSelect,
  }
}

export default useJobParallelism
